/* global fetch, loadmore_params */

const post = (url, body) => {
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body
        })
            .then(res => res.text())
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
};

const archive = document.querySelector('.archive');

if (archive) {
    const loadMoreButton = archive.querySelector('.loadmore');
    const list = archive.querySelector('.archive-list');

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', () => {
            loadMoreButton.innerText = 'Laster...';

            post(
                loadmore_params.ajaxurl,
                `action=loadmore&page=${loadmore_params.current_page}&query=${loadmore_params.posts}`
            )
                .then(data => {
                    if (data) {
                        list.innerHTML += data;
                    }

                    loadMoreButton.innerText = 'Se flere';

                    loadmore_params.current_page++;

                    // eslint-disable-next-line eqeqeq
                    if (loadmore_params.current_page == loadmore_params.max_page) {
                        loadMoreButton.style.display = 'none';
                    }
                })
                .catch(e => {
                    loadMoreButton.innerText = 'Se flere';
                });
        });
    }
}
